module.exports = "/static/assets/66bc71cc7b7e48ee3449bc35de71545f.png";